import { render, staticRenderFns } from "./AMRelic80NEW.vue?vue&type=template&id=dc4ef790&scoped=true"
import script from "./AMRelic80NEW.vue?vue&type=script&lang=ts"
export * from "./AMRelic80NEW.vue?vue&type=script&lang=ts"
import style0 from "./AMRelic80NEW.vue?vue&type=style&index=0&id=dc4ef790&prod&lang=scss&scoped=true"
import style1 from "./AMRelic80NEW.vue?vue&type=style&index=1&id=dc4ef790&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4ef790",
  null
  
)

export default component.exports